// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-preview[data-v-853da676]{position:sticky;top:0!important;-ms-flex-item-align:start;align-self:flex-start;height:-webkit-max-content;height:-moz-max-content;height:max-content;z-index:10}", ""]);
// Exports
module.exports = exports;
